import {ICrudLocale} from "../../../i18n/interface";
import {ERROR} from "@angular/compiler-cli/src/ngtsc/logging/src/console_logger";
import {DELETE} from "@angular/cdk/keycodes";

export const USER_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  USER_MANAGEMENT: {
    LABEL: {
      SINGULAR: 'Usuario',
      PLURAL: 'Usuarios',
    },
    FIELD: {
      NAME: 'Nombre',
      USERNAME: 'Usuario',
      EMAIL: 'Email',
      GENDER: 'Género',
      ENABLED: 'Activo',
      LASTNAME: 'Apellido',
      PASSWORD: 'Contraseña',
      MOBILE: 'Teléfono',
      ROL: 'Rol',
      GROUPS: 'Tipos de usuario',
      GROUP: 'Tipo de usuario',
      BIRTHDATE: 'Fecha de nacimiento',
      SELF_GENERATED_PASSWORD: 'Contraseña autogenerada',
      LAST_LOGIN: 'Último acceso',
      CENTER: 'Centro',
      NUMBER_ID: 'Número de identificación',
      DOC_TYPE: {
        DNI: 'DNI',
        NIE: 'NIE',
        PASSPORT: 'Pasaporte',
      }
    },
    TEXT: {
      DELETE_MESSAGE: 'Si lo eliminas, todos los datos serán borrados.<br> <b>Esta acción no es reversible.</b>'
    },
    ERROR: {
      LOAD_FORM_RESOURCES: 'Lo sentimos ha ocurrido un error al cargar el formulario.'
    },
    LIST: {
      TITLE: 'Listado de usuarios',
      FILTERS: 'Filtros',
    },
  }
};
